import React from "react";
import { Ticket } from "../../../models/Ticket";
import "./styleMobile.scss";
import { TbTicket } from "react-icons/tb";
import { BiError } from "react-icons/bi";
import { useTranslation } from "react-i18next";
interface IProps {
  ticket: Ticket;
  handleSetOpenDayChoose: () => void;
}

const TicketNoExerciseMobile: React.FC<IProps> = ({ ticket, handleSetOpenDayChoose }: IProps) => {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <div className="future-ticket">
        <div className="future-ticket-date flex-start-center">
          <div className="future-ticket-mini-calendar flex-center-center flex-wrap">
            <BiError className="cancel-info" />
          </div>
          <div className="future-ticket-date-text flex-column">
            <b className="cancel-info">{t("odwolales_wizyte")}</b>
          </div>
        </div>
        <div className="future-ticket-line"></div>
        <div className="future-ticket-body">
          <div className="flex-start-center">
            <TbTicket className="icon" /> <b>{ticket.name}</b>
          </div>
        </div>

        <div className="future-ticket-buttons flex-column">
          <div className="alert alert-red">{t("aby_wykorzystac_bilet_wybierz_termin")}</div>
          <button
            onClick={() => handleSetOpenDayChoose()}
            className="button medium padding-medium button-fill-main full-button"
          >
            {t("zmien_termin")}
          </button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default TicketNoExerciseMobile;
